__turbopack_context__.v({
  "content": "Quote-module-scss-module__RWMRRa__content",
  "disclaimer": "Quote-module-scss-module__RWMRRa__disclaimer",
  "quote": "Quote-module-scss-module__RWMRRa__quote",
  "title": "Quote-module-scss-module__RWMRRa__title",
});
